namespace GeniuzPOS.PosShift {
    export enum CusTaxTypeFg {
        Individual = 1,
        Legalentity = 2,
        IndividualForeign = 3,
        LegalForeign = 4
    }
    Serenity.Decorators.registerEnumType(CusTaxTypeFg, 'GeniuzPOS.PosShift.CusTaxTypeFg');
}
